// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manuals-wrapper {
  padding-bottom: 20px;
}
.manuals-wrapper .search-bar-wrapper {
  padding: 30px 0;
  background-color: var(--background-color);
}
.manuals-wrapper .search-bar-wrapper .search-bar-components {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: auto;
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .rich-text__heading {
  margin: auto;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components {
    width: 100%;
  }
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code {
  padding-top: 10px;
  margin: auto;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code {
    margin: 0 25px;
  }
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper {
  display: flex;
  flex-direction: row;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper {
    flex-direction: column;
  }
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper button {
    width: 50%;
    margin: 20px auto;
  }
}
.manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper input {
  padding: 16px;
  height: 50px;
  background: transparent;
  font-size: 16px;
  width: 300px;
  margin-right: 10px;
}
@media (max-width: 550px) {
  .manuals-wrapper .search-bar-wrapper .search-bar-components .caliber-search-code .filter-wrapper input {
    margin: 0;
    width: 100%;
  }
}
.manuals-wrapper .table-container {
  padding-top: 50px;
  max-width: 1150px;
  margin: auto;
}
.manuals-wrapper .table-container .manuals-text-description {
  text-align: left;
  height: 24px;
}
@media (max-width: 768px) {
  .manuals-wrapper .table-container thead {
    display: none;
  }
  .manuals-wrapper .table-container .manual-content-wrapper {
    border: 0;
  }
  .manuals-wrapper .table-container .manual-content-wrapper tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td,
  .manuals-wrapper .table-container .manual-content-wrapper th {
    display: block;
    text-align: center;
    border: 0;
    padding: 8px;
    position: relative;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td:last-child {
    margin-bottom: 0;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td a {
    text-decoration: none;
    color: #007bff;
  }
  .manuals-wrapper .table-container .manual-content-wrapper td a:hover {
    text-decoration: underline;
  }
}
.manuals-wrapper .table-container table {
  width: 100%;
  font-weight: 500;
  border-collapse: collapse;
}
.manuals-wrapper .table-container table th,
.manuals-wrapper .table-container table td {
  padding: 12px 16px;
  border: 1px solid #e6e6e6;
}
.manuals-wrapper .table-container table thead {
  background-color: #f0f0f0;
}
.manuals-wrapper .table-container table tbody tr {
  transition: opacity 0.5s ease;
  opacity: 1;
}
.manuals-wrapper .table-container table tbody tr.hidden {
  opacity: 0;
  display: none;
  height: 0;
  overflow: hidden;
}
.manuals-wrapper .table-container table tbody th {
  text-align: left;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper {
  padding-bottom: 7px;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper a {
  color: #193c72;
  text-decoration: underline;
}
.manuals-wrapper .table-container table tbody td .manual-wrapper:last-child {
  padding-bottom: 0;
}
.manuals-wrapper .table-container table tbody td .manual-button {
  width: 100%;
}
.manuals-wrapper .table-container .no-item {
  margin: auto;
  padding: 1.5rem;
  border: 1px solid #e6e6e6;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/manuals/manuals.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AACE;EACE,eAAA;EACA,yCAAA;AACJ;AACI;EAKE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;AAHN;AAJM;EACE,YAAA;AAMR;AAEM;EAVF;IAWI,WAAA;EACN;AACF;AACM;EACE,iBAAA;EACA,YAAA;AACR;AACQ;EAJF;IAKI,cAAA;EAER;AACF;AAAQ;EACE,aAAA;EACA,mBAAA;AAEV;AAAU;EAJF;IAKI,sBAAA;EAGV;AACF;AAAY;EADF;IAEI,UAAA;IACA,iBAAA;EAGZ;AACF;AAAU;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAEZ;AAAY;EARF;IASI,SAAA;IACA,WAAA;EAGZ;AACF;AAIE;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;AAFJ;AAII;EACE,gBAAA;EACA,YAAA;AAFN;AAKI;EACE;IACE,aAAA;EAHN;EAMI;IACE,SAAA;EAJN;EAMM;IACE,cAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,YAAA;EAJR;EAOM;;IAEE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,YAAA;IACA,kBAAA;EALR;EASM;IACE,gBAAA;EAPR;EAUM;IACE,qBAAA;IACA,cAAA;EARR;EAWM;IACE,0BAAA;EATR;AACF;AAaI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAXN;AAaM;;EAEE,kBAAA;EACA,yBAAA;AAXR;AAcM;EACE,yBAAA;AAZR;AAgBQ;EACE,6BAAA;EACA,UAAA;AAdV;AAiBQ;EACE,UAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AAfV;AAkBQ;EACE,gBAAA;AAhBV;AAoBU;EACE,mBAAA;AAlBZ;AAoBY;EACE,cAAA;EACA,0BAAA;AAlBd;AAsBU;EACE,iBAAA;AApBZ;AAuBU;EACE,WAAA;AArBZ;AA2BI;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAzBN","sourcesContent":[".manuals-wrapper {\n  padding-bottom: 20px;\n\n  .search-bar-wrapper {\n    padding: 30px 0;\n    background-color: var(--background-color);\n\n    .search-bar-components {\n      .rich-text__heading {\n        margin: auto;\n      }\n\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      margin: auto;\n\n      @media (max-width: 550px) {\n        width: 100%;\n      }\n\n      .caliber-search-code {\n        padding-top: 10px;\n        margin: auto;\n\n        @media (max-width: 550px) {\n          margin: 0 25px;\n        }\n\n        .filter-wrapper {\n          display: flex;\n          flex-direction: row;\n\n          @media (max-width: 550px) {\n            flex-direction: column;\n          }\n\n          button {\n            @media (max-width: 550px) {\n              width: 50%;\n              margin: 20px auto;\n            }\n          }\n\n          input {\n            padding: 16px;\n            height: 50px;\n            background: transparent;\n            font-size: 16px;\n            width: 300px;\n            margin-right: 10px;\n\n            @media (max-width: 550px) {\n              margin: 0;\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .table-container {\n    padding-top: 50px;\n    max-width: 1150px;\n    margin: auto;\n\n    .manuals-text-description {\n      text-align: left;\n      height: 24px;\n    }\n\n    @media (max-width: 768px) {\n      thead {\n        display: none;\n      }\n\n      .manual-content-wrapper {\n        border: 0;\n\n        tr {\n          display: block;\n          margin-bottom: 1rem;\n          border: 1px solid #ddd;\n          border-radius: 8px;\n          padding: 8px;\n        }\n\n        td,\n        th {\n          display: block;\n          text-align: center;\n          border: 0;\n          padding: 8px;\n          position: relative;\n        }\n\n\n        td:last-child {\n          margin-bottom: 0;\n        }\n\n        td a {\n          text-decoration: none;\n          color: #007bff;\n        }\n\n        td a:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    table {\n      width: 100%;\n      font-weight: 500;\n      border-collapse: collapse;\n\n      th,\n      td {\n        padding: 12px 16px;\n        border: 1px solid #e6e6e6;\n      }\n\n      thead {\n        background-color: #f0f0f0;\n      }\n\n      tbody {\n        tr {\n          transition: opacity 0.5s ease;\n          opacity: 1;\n        }\n\n        tr.hidden {\n          opacity: 0;\n          display: none;\n          height: 0;\n          overflow: hidden;\n        }\n\n        th {\n          text-align: left;\n        }\n\n        td {\n          .manual-wrapper {\n            padding-bottom: 7px;\n\n            a {\n              color: #193c72;\n              text-decoration: underline;\n            }\n          }\n\n          .manual-wrapper:last-child {\n            padding-bottom: 0;\n          }\n\n          .manual-button {\n            width: 100%;\n          }\n        }\n      }\n    }\n\n    .no-item {\n      margin: auto;\n      padding: 1.5rem;\n      border: 1px solid #e6e6e6;\n      text-align: center;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
